
import React from 'react';
import Store from '../../redux/store';
import '../../resources/css/notice-page.css';
import i18n from '../../i18n';
import { withSnackbar, WithSnackbarProps } from 'notistack';
import { MessengerModule } from '../../messenger/module';
import _ from 'lodash';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import { Button, TextField, IconButton, InputAdornment, FormControl } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { getCacheField } from '../../tools/get-cache-field';
import { BusinessMenu, Menu, QopCreateOrder, TableStatus } from '../../constants/type.constant';
import { WebsocketClient } from '../../websocket/module';
import ShoppingCart from '../../modules/shopping-cart';
import { getWebsocketUrl, PHONE_TYPE } from '../../tools/utils';
import { DefaultRequest } from '../../requests/default.request';
import { SendOrderRequestEventObject } from '../../websocket/type';
import { createHashHistory } from 'history';
import { StateManager } from '../../redux/stateManager';
import io from 'socket.io-client';
import MenuItem from './home-menu-item.componemt';
import moment from 'moment-timezone';
import { isNewBusiness, scheduleTransform, getCurrentBusinessMenu } from '../../constants/tools.constant';
import { getSettingInfo } from '../../tools/get-setting-info';
import { setLocalDateByDiff } from '../../tools/local-moment';

class FooterBar extends React.Component<Props, State>{
    public messengerModule: MessengerModule;
    public scrollHomeViewTimeOut!: NodeJS.Timeout;
    public scrollCount = 0;
    public adaptationView = PHONE_TYPE.indexOf('iPhone') > -1 && PHONE_TYPE.indexOf('Safari') > -1;
    // 基础设置中的开桌模式
    public openMode: number = 0;
    public diffTimeStamp = Store.getState().diffTimeStamp;

    constructor(props: Props) {
        super(props);
        this.state = {
            isTouchMove: false,
            touchStartY: 0,
            touchEndY: 0,
            isShowHomeOrder: false,
            selectedMenuId: 0,
            // 人数
            person: [{
                type: 'NORMAL',
                num: 0,
            }, {
                type: 'CHILD',
                num: 0,
            }],
            // 当前桌台状态
            resultTableStatus: [],
            isLoading: false,
            // 是否开启审核功能
            isApproved: true,
            // 是否开启自主点餐模式
            autonomous: {
                status: false
            },
            // 用数组形式存储人数
            peopleArr: [],
            // 额外费用ID
            menuId: 0,
            // 是否明文密码
            showPassword: false,
            // 订单加密码
            orderCode: '',
            // 输入框位移动画
            inputAnimationStatus: 0,
            isOpenPIN: 0

        }
        this.messengerModule = new MessengerModule(this.props.enqueueSnackbar);
        this.createOrder = this.createOrder.bind(this);
    }

    // *********************
    // 生命周期
    // *********************

    public async componentDidMount() {

        // 获取桌台状态
        try {
            let resultTableStatus = StateManager.getFromCache('tableStatusById');
            if (_.isEmpty(resultTableStatus)) {
                resultTableStatus = await DefaultRequest.getTableSById(StateManager.getFromCache('tableId'));
                // 当前桌台状态存入缓存
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'tableStatusById',
                    value: resultTableStatus,
                })
            }
            this.setState({ resultTableStatus });
        } catch (error) {
            this.messengerModule.say({
                message: `${i18n.t('general_text_update_faild')}`,
                level: 'Warning'
            })
        }
        // 没有桌台id，跳回启动页
        if (!getCacheField('tableId')) {
            createHashHistory().push({ pathname: '/' });
        }
        // 获取桌台状态
        let resultTableStatusPerson = getCacheField('orderTab.person')

        // 有订单id && 菜单id不为空 跳到菜单页
        // if (getCacheField('orderTab.orderId') && getCacheField('orderTab.menuList.main_group_id') && resultTableStatusPerson) {
        //     createHashHistory().push({ pathname: '/Main' });
        // }
        WebsocketClient.joinOrder(getCacheField('tableId'))
        // 获取菜单
        await this.getSetting();
        // 获取缓存开台模式
        // - 0 服务员开台
        // - 1 自主开台
        this.openMode = _.get(this.getSettingInfoValue('qop_open-table-mode'), 'value', 0);

        // $ 判断订单推送请求 有其他人发起，直接跳转到菜单页
        WebsocketClient.addListener('SEND_ORDER_REQUEST', this.sendOrderRequestListener)
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'advGlobalRound',
            value: 1
        })
    }

    public componentWillUnmount() {
        document.removeEventListener('scroll', this.scrollHomeView);
        WebsocketClient.removeListener('SEND_ORDER_REQUEST', this.sendOrderRequestListener)
        this.setState = (state, callback) => { return; };
    }

    // *********************
    // 方法区
    // *********************

    public getViewStyle() {
        this.adaptationView = PHONE_TYPE.indexOf('iPhone') > -1 && PHONE_TYPE.indexOf('Safari') > -1;
        if (PHONE_TYPE.indexOf('Android') > -1 && PHONE_TYPE.indexOf('XiaoMi') > -1) return "auto-table-box";
        return this.adaptationView ? "auto-table-box-safari" : 'auto-table-box-chrome'
    }

    public scrollHomeView = () => {
        clearTimeout(this.scrollHomeViewTimeOut)
        let menuTop = document.getElementById('homeMainTop');
        this.scrollCount += 1;
        // 性能优化 ,限制100ms内只执行一遍
        this.scrollHomeViewTimeOut = setTimeout(() => {
            if (menuTop ? menuTop.scrollTop === 0 : 0) {
                if (this.state.isTouchMove) {
                    this.setState({ isTouchMove: false });
                }
            }
            this.scrollCount = 0;
        }, 100);
    }

    /**
     * SEND_ORDER_REQUEST 监听发送请求
     */
    public sendOrderRequestListener = async (data: SendOrderRequestEventObject) => {
        const { orderRequestMsg, orderId } = data;
        console.log(orderRequestMsg, 'SEND_ORDER_REQUEST');
        this.messengerModule.say({
            message: `${i18n.t('menu_page_text_order_success_created_jump')}`,
            level: "Success",
        });
        if (data.dish) {
            ShoppingCart.metaData = data.dish
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'shoppingCart',
                value: data.dish
            })
        }
        // 审核状态

        if (getCacheField('tableStatus')) {
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'approvalStatus',
                value: 'NO',
            })
        } else {
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'approvalStatus',
                value: this.state.isApproved ? 'REVIEW' : 'NO',
            })
        }

        // 开台请求的信息
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'orderRequestMsg',
            value: orderRequestMsg
        })

        // 开台信息
        const ORDERID = orderId ? orderId : getCacheField('orderTab.orderId')
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'orderTab',
            value: {
                person: orderRequestMsg.adultNum + orderRequestMsg.childNum + Number(orderRequestMsg.otherNum),
                orderId: ORDERID,
                menuList: orderRequestMsg.menu,
                customer: this.state.autonomous.status ? getCacheField('orderTab.customer') : '1',
                childNum: orderRequestMsg.childNum,
                otherNum: orderRequestMsg.otherNum,
                normalNum: orderRequestMsg.adultNum,
                // 订单临时码
                orderCode: orderRequestMsg.orderCode,
            }
        })
        // 重新发送按钮倒计时
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'resendOrderSecond',
            value: 60,
        })
        !this.state.isApproved && await this.getGenerateCustomerName(ORDERID);
        createHashHistory().push({ pathname: 'Main' });
    }
    /**
     * 获取自动生成的客户名称
     */
    public async getGenerateCustomerName(orderId: number) {
        try {
            let result = await DefaultRequest.getGenerateCustomerName(orderId)
            let customer = result.now_customer_name ? result.now_customer_name.toString() : ''

            Store.dispatch({
                type: 'SET_CACHING',
                path: 'orderTab.customer',
                value: this.state.autonomous.status ? customer : '1'
            })
        }
        catch (error) {
            console.log(error)
        }
    }

    /**
     * 获取基础设置
     * @param str 
     * @returns 
     */
    public getSettingInfoValue(str: string) {
        const SETTING = getCacheField('settingInfo');
        return _.find(SETTING, ['name', str]);
    }

    /**
     * 获取默认菜单
     * 根据新旧营业时间获取默认菜单
     * @returns
     */
    async getDefaultMenu(): Promise<number[]> {
        try {
            let defaultMenu: number[] = [];
            // 新营业时间
            if (isNewBusiness()) {
                // 从缓存中获取当前营业时间段
                let currentMenu: BusinessMenu[] = getCacheField('currentMenu');
                // 缓存中没有当前营业时间段
                if (currentMenu && currentMenu.length === 0) {
                    const result = await DefaultRequest.getBusinessHour2Project();
                    const SCHEDULE = scheduleTransform(_.get(result, '[0].value', []));
                    currentMenu = getCurrentBusinessMenu(SCHEDULE)

                }
                const curDefaultMenu = _.get(currentMenu, '[0].default_menu', '');
                // 转成number[]格式
                if (_.isEmpty(curDefaultMenu)) {
                    defaultMenu = [];
                }
                else {
                    defaultMenu = curDefaultMenu
                        .split(',')
                        .map((item: string) => Number(item));
                }
            }
            // 旧营业时间
            else {
                // 必选菜单
                defaultMenu = getSettingInfo('default-selection-menu', 'value').defaultMenu;
            }
            // 排序 从小至大
            defaultMenu.sort((a, b) => { return a - b });
            return defaultMenu
        }
        catch (e) {
            return []
        }
    }

    // 创建订单
    createOrder = async () => {
        const { specialMenu, normalMenu } = this.props;
        const { peopleArr, autonomous, person, isApproved, resultTableStatus, selectedMenuId, orderCode } = this.state;
        // JK 开台
        const tableStatusInfo = resultTableStatus?.[0] || {};
        // JK 开台 没有菜单选择
        const notHasSeletMenu = tableStatusInfo.order_head_id &&
            (!tableStatusInfo?.select_menu
                && (tableStatusInfo?.table_status === 3 ||
                    tableStatusInfo?.table_status === 2)) ||
            tableStatusInfo?.table_status === 4;
        let childNum = 0;
        let normalNum = 0;
        let otherNum = 0;
        if (notHasSeletMenu) {
            childNum = tableStatusInfo.child_number || 0;
            otherNum = tableStatusInfo.other_number || 0;
            normalNum = (tableStatusInfo.customer_num - childNum - otherNum) || 1;
        } else {
            person.forEach((item) => {
                if (item.type === 'NORMAL') {
                    normalNum = item.num
                }
                else if (item.type === 'CHILD') {
                    childNum = item.num
                }
                else {
                    otherNum = item.num
                }
            })
        }
        let peopleNum: number = childNum + normalNum + otherNum;
        const MENU_ITEM = [...specialMenu, normalMenu]
        const findItem = MENU_ITEM.find((item) => {
            return selectedMenuId === item.main_group_id;
        })
        if (findItem && peopleNum) {
            // 选中的菜品
            let select_menu = findItem;
            let defaultMenu = await this.getDefaultMenu();
            // 桌台id
            let tableId = getCacheField('tableId');
            // 桌台名称
            let tableName = getCacheField('tableName');
            //  选择菜品
            if (select_menu?.main_group_name && tableId) {
                // Footer栏目控制的页面切换
                Store.dispatch({
                    type: 'SET',
                    path: 'viewPage',
                    value: 'menuPage',
                });
                // 审核状态
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'approvalStatus',
                    value: isApproved ? 'REVIEW' : 'NO',
                })
                // 清空点餐页面之前选的菜单
                Store.dispatch({
                    type: 'SET',
                    path: 'selectedFirstLevelMenu',
                    value: {
                        main_group_name: '',
                        main_group_id: 0,
                        menu_item_slu: [],
                    }
                })
                const PARM: QopCreateOrder = {
                    // 订单备注
                    check_name: "",
                    // 客户数量
                    customer_num: peopleNum,
                    // 就餐方式: 0:堂吃，1:堂吃打包，2:外送，3:来店自取
                    eat_type: 0,
                    // 开台id
                    table_id: tableId,
                    // 开台菜单
                    select_menu: `${select_menu.main_group_id},${defaultMenu.toString()}`,
                    // 大人人数
                    adult_number: normalNum,
                    // 小孩人数
                    child_number: childNum,
                    // 其他人数
                    other_number: otherNum,
                    // 用于记录项目名称
                    system_type: 'QOP',
                    // 订单临时码
                    order_code: orderCode,
                    // 用于记录项目名称
                    project_name: 'QOP'
                };

                let RESORDER = { orderId: 0 };
                // JK 开台无需再创建订单
                if (!notHasSeletMenu) {
                    //
                    if (!isApproved) {
                        if (resultTableStatus[0].table_status === 3) {
                            RESORDER.orderId = resultTableStatus[0].order_head_id;
                        } else {
                            RESORDER = await DefaultRequest.createOrderNotCheckTable(PARM);
                        }
                    }
                } else {
                    RESORDER = { orderId: tableStatusInfo.order_head_id || 0 };
                }


                // 订单信息
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'orderTab',
                    value: {
                        // 开台人数
                        person: peopleNum,
                        // 订单Id
                        orderId: isApproved ? getCacheField('orderTab.orderId') : RESORDER.orderId,
                        // 菜单信息
                        menuList: {
                            // id
                            main_group_id: select_menu.main_group_id,
                            // name
                            main_group_name: select_menu.main_group_name,
                        },
                        // 扫码id
                        customer: getCacheField('orderTab.customer') || '1',
                        // 开台具体人数
                        childNum: childNum,
                        otherNum: otherNum,
                        normalNum: normalNum,
                        // 订单临时码
                        orderCode: orderCode,
                    },
                })

                try {
                    //修改桌台状态为已开台 未审核
                    // const UPDATETAB = await DefaultRequest.updateTableSById(tableId, { table_status: 3, cor_status: 0 });
                    // if (UPDATETAB.status === 200) { }
                    ShoppingCart.customerNum = peopleNum
                    // 初始化购物车人数
                    if (autonomous.status && !_.has(ShoppingCart.metaData, `${ShoppingCart.globalRound}`)) {

                        peopleArr.forEach((customer: string, index: number) => {
                            // 检查顾客是否存在
                            if (!_.has(ShoppingCart.metaData, `${ShoppingCart.globalRound}.${customer}`)) {
                                _.set(ShoppingCart.metaData, `${ShoppingCart.globalRound}.${customer}`, []);
                            }
                        })
                    }

                    // （逻辑加固）检测顾客"0"是否存在，存在赋值空数组
                    if (_.has(ShoppingCart.metaData, `${ShoppingCart.globalRound}.0`)) {
                        _.set(ShoppingCart.metaData, `${ShoppingCart.globalRound}.0`, [])
                    }
                    Store.dispatch({
                        type: 'SET_CACHING',
                        path: 'shoppingCart',
                        value: ShoppingCart.metaData
                    })
                    !this.state.isApproved && await this.getGenerateCustomerName(RESORDER.orderId);
                    await this.createOrderRequest(
                        tableId,
                        tableName,
                        select_menu,
                        {
                            orderId: RESORDER.orderId,
                            // 大人人数
                            adult_number: normalNum,
                            // 小孩人数
                            child_number: childNum,
                            // 其他人数
                            other_number: otherNum
                        }
                    );
                    createHashHistory().push({ pathname: '/Main' });
                    // 重新发送倒计时
                    Store.dispatch({
                        type: 'SET_CACHING',
                        path: 'resendOrderSecond',
                        value: 60
                    })
                } catch (error) {
                    // this.messengerModule.say({
                    //     message: error,
                    //     level: 'Warning'
                    // })
                    console.log(error)
                    this.setState({ isLoading: false })
                }
            } else if (tableId === undefined) {
                this.messengerModule.say({
                    message: `${i18n.t('menu_page_text_table_invalid')}`,
                    level: "Warning",
                });
                this.setState({ isLoading: false })
                createHashHistory().push({ pathname: '/' });
            } else {
                this.setState({ isLoading: false })
                this.messengerModule.say({
                    message: `${i18n.t('home_page_text_please_select_menu')}`,
                    level: "Warning",
                });
            }
        }
    }

    // 人数增减
    public changePeoNum = (num: number, type: PersonType) => {
        try {
            const { resultTableStatus } = this.state;
            let { person, peopleArr } = this.state;
            if (_.get(resultTableStatus, `0.customer_num`) === null) {
                person.forEach((item) => {
                    if (item.type === type) {
                        if (item.num + num > -1) {
                            item.num = item.num + num
                        }
                    }
                })
                this.setState({
                    person
                }, async () => {
                    let normalNum: number = 0;
                    let childNum: number = 0;
                    let otherNum: number = 0;
                    person.forEach((item) => {
                        if (item.type === 'NORMAL') {
                            normalNum = item.num
                        } else if (item.type === 'CHILD') {
                            childNum = item.num
                        }
                        else {
                            otherNum = item.num
                        }
                    })
                    let peopleNum: number = childNum + normalNum + otherNum;
                    peopleArr.push(`${peopleNum}`);
                    peopleArr.length = peopleNum;
                    this.setState({
                        peopleArr: Array.from(new Set(peopleArr))
                    })
                })
            } else {
                // 判断聚客开的桌台
                person.forEach((item) => {
                    if (item.type === type) {
                        if (item.num + num > -1) {
                            item.num = item.num + num
                        }
                    }
                })
                this.setState({
                    person
                }, async () => {
                    let normalNum: number = 0;
                    let childNum: number = 0;
                    let otherNum: number = 0;
                    person.forEach((item) => {
                        if (item.type === 'NORMAL') {
                            normalNum = item.num
                        } else if (item.type === 'CHILD') {
                            childNum = item.num
                        } else {
                            otherNum = item.num
                        }
                    })
                    let peopleNum: number = childNum + normalNum + otherNum;
                    peopleArr.push(`${peopleNum}`);
                    peopleArr.length = peopleNum;
                    this.setState({
                        peopleArr: Array.from(new Set(peopleArr))
                    })
                })
            }
        } catch (error) {
            // this.messengerModule.say({
            //     message: error,
            //     level: 'Warning'
            // })
            console.log(error)
        }

    }

    public async getSetting() {
        try {
            let settingInfo = await DefaultRequest.getSettingInfo();
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'settingInfo',
                value: settingInfo
            });
            // 自主点餐
            const AUTONOMOUS = settingInfo.find((target: any) => {
                return target.name === 'rule-autonomous-meal'
            })
            // 是否开启审核功能
            const ISAPPROVED = settingInfo.find((target: any) => {
                return target.name === 'open-table-audit'
            })
            // 额外费用id
            const MENUID = settingInfo.find((target: any) => {
                return target.name === 'package-fee'
            })
            // 获取临时密码是否启用
            const isOpenPIN = settingInfo.find((target: any) => {
                return target.name === 'order_head_password'
            })

            this.setState({
                menuId: MENUID ? MENUID.value.menu_id : 0,
                isApproved: ISAPPROVED ? ISAPPROVED.value.enable : true,
                autonomous: AUTONOMOUS ? AUTONOMOUS.value : {
                    status: false
                },
                isOpenPIN: isOpenPIN ? isOpenPIN.value : 0
            })
            // MENUID && this.setState({ menuId: MENUID.value.menu_id })
            // ISAPPROVED && this.setState({ isApproved: ISAPPROVED.value.enable })
            // AUTONOMOUS && this.setState({ autonomous: AUTONOMOUS.value })

        } catch (error) {
            console.log(error);
        }
    }
    /**
     * 发送创建订单的请求
     * @param tableId 桌台id
     * @param  select_menu 选择的菜品
     */
    async createOrderRequest(tableId: number, tableName: string, select_menu: Menu, param: {
        // 订单ID
        orderId: number;
        // 大人人数
        adult_number: number;
        // 小孩人数
        child_number: number;
        // 其他人数
        other_number?: number;
    }) {
        const { isApproved, resultTableStatus } = this.state;
        // 必选菜单ids
        let defaultMenu = await this.getDefaultMenu();
        let selectMenu = {
            // id
            main_group_id: select_menu.main_group_id,
            // name
            main_group_name: select_menu.main_group_name
        };
        let childNum: number = 0;
        let normalNum: number = 0;
        let otherNum: number = 0;
        this.state.person.forEach((item) => {
            if (item.type === 'NORMAL') {
                normalNum = item.num
            } else if (item.type === 'CHILD') {
                childNum = item.num
            } else {
                otherNum = item.num
            }
        })

        // 开桌信息
        const updateOrdersParameter = [
            {
                order_head_id: _.get(resultTableStatus, '0.order_head_id'),
                select_menu: `${select_menu.main_group_id},${defaultMenu.toString()}`,
                // jk 开台，不得再次修改人数
                // customer_num: param.adult_number + param.child_number + Number(param.other_number),
                // child_number: param.child_number,
                // adult_number: param.adult_number,
                // other_number: Number(param.other_number),
            }
        ]

        if (_.get(resultTableStatus, '0')) {
            // 用于区分聚客服务端开的桌台 (无人数)
            if ((resultTableStatus[0].table_status === 3 || resultTableStatus[0].table_status === 2 || resultTableStatus[0].table_status === 4)
                && resultTableStatus[0].cor_status === 1 && resultTableStatus[0].customer_num === 0) {
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'orderTab.menuList',
                    value: selectMenu,
                })
                // 审核状态
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'approvalStatus',
                    value: 'NO',
                })
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'advGlobalRound',
                    value: 1,
                })
                ShoppingCart.globalRound = 1;
                // 当jk开台没人数，则默认为1
                _.set(updateOrdersParameter[0], 'customer_num', 1);
                _.set(updateOrdersParameter[0], 'adult_number', 1);
                // 更新订单开桌信息
                await DefaultRequest.updateOrdersStatus(updateOrdersParameter);
            }

            // 用于区分聚客服务端开的桌台 (有人数)
            if (
                (resultTableStatus[0].customer_num !== 0 &&
                    !resultTableStatus[0].select_menu && (resultTableStatus[0].table_status === 3 ||
                        resultTableStatus[0].table_status === 2)) ||
                resultTableStatus[0].table_status === 4) {

                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'advGlobalRound',
                    value: 1,
                })
                ShoppingCart.globalRound = 1
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'orderTab.menuList',
                    value: selectMenu,
                })
                // 审核状态
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'approvalStatus',
                    value: 'NO',
                })
                // 更新订单开桌信息
                await DefaultRequest.updateOrdersStatus(updateOrdersParameter)
                // // 获取额外费用信息
            }
        }

        // $ 向服务端发送订单审核请求
        const msgSocket = io(`ws://${getWebsocketUrl()}`);
        const sendOrderRequest = {
            type: 'QOP_CREATE_ORDER_REQUEST',
            tableId: tableId.toString(),
            table_name: tableName,
            menu: selectMenu,
            adultNum: normalNum,
            childNum: childNum,
            otherNum: otherNum,
            person: childNum + normalNum + otherNum,
            customer: getCacheField('orderTab.customer'),
            orderCode: this.state.orderCode
        }
        // 发送到 '呼叫服务'
        if (isApproved && _.get(resultTableStatus, '0.table_status') !== 3 && _.get(resultTableStatus, '0.table_status') !== 2) {
            msgSocket.emit('CALL_SERVICE', sendOrderRequest);
        } else {
            // 更新桌台状态
            await DefaultRequest.updateTableSById(tableId, { table_status: 3, cor_status: 1 });
            if (_.get(resultTableStatus, '0.table_status') !== 3 && _.get(resultTableStatus, '0.table_status') !== 2) {
                // 获取额外费用信息
                await DefaultRequest.genExtraCostByFirstMenu({
                    // 订单id
                    id: param.orderId,
                    // 1级菜单id,数组
                    first_menu: [select_menu.main_group_id],
                    // 额外费用菜单idS
                    menu_id: this.state.menuId,
                    // 操作人员id
                    open_employee_id: 101,
                    // 操作人员名称
                    open_employee_name: 101,
                    // 当前周几，0-6 0是周日
                    week: moment(setLocalDateByDiff(this.diffTimeStamp)).weekday()
                })
            }
        }
        // $ 向其他人发起创建订单请求，直接跳转到菜单页
        WebsocketClient.emitOrderClients({
            event: 'SEND_ORDER_REQUEST',
            customer: getCacheField('orderTab.customer'),
            orderRequestMsg: sendOrderRequest,
            dish: ShoppingCart.metaData,
            orderId: param.orderId
        })
        const orderTab = Store.getState().orderTab;
        orderTab.menuList = selectMenu;
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'orderTab',
            value: orderTab
        })
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'orderRequestMsg',
            value: sendOrderRequest
        })
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'isOpenTab',
            value: true
        })
    }

    /**
     * 选择菜单
     * @param menuId
     */
    selectMenu(val: { selectedMenuId: number }) {
        const { selectedMenuId } = val;
        const { specialMenu, normalMenu } = this.props;
        const { person } = this.state;
        const MENU_ITEM = [...specialMenu, normalMenu];
        // 选中的菜单
        const findItem = MENU_ITEM.find((item) => {
            return selectedMenuId === item.main_group_id;
        })
        // 选中的菜单有其他价格则显示其他人数选项
        if (findItem?.other_price) {
            if (person.length === 2) {
                person.push({
                    type: 'OTHER',
                    num: 0
                })
            }

        }
        else {
            if (person.length === 3) {
                person.splice(2, 1)
            }
        }
        this.setState({
            person,
            selectedMenuId
        })
    }

    checkTableStatus = async () => {
        // 缓存中的桌台状态
        const storeTableStatus = StateManager.getFromCache('tableStatusById');
        // 缓存中的桌台状态
        const resultTableStatus = await DefaultRequest.getTableSById(StateManager.getFromCache('tableId'));
        let resultTableInfo: TableStatus | undefined = _.get(resultTableStatus, '0');
        const tableStatus = resultTableInfo?.table_status;
        if (_.get(storeTableStatus, '[0].table_status') !== tableStatus && resultTableInfo) {
            // 判断该桌是否为合并桌
            if (resultTableInfo.merge_status) {
                const mergeTargetTableId = _.get(resultTableInfo, 'merge_target_table.table_id');
                if (mergeTargetTableId) {
                    const mergeTargetRes = await DefaultRequest.getTableSById(parseInt(mergeTargetTableId));
                    resultTableInfo = mergeTargetRes[0];
                }
            }
            const { table_id, cor_status, table_status, select_menu, table_name, order_head_id, customer_num, child_number, adult_number, other_number } = resultTableInfo;
            // 当前扫码时间戳存入缓存
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'qrCodeDate',
                value: Number(new Date())
            })
            // 当前桌台状态存入缓存
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'tableStatusById',
                value: [resultTableInfo],
            })
            WebsocketClient.joinOrder(parseInt(`${table_id}`));
            // $ 初始化 购物车
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'shoppingCart',
                value: {}
            })
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'liteMode',
                value: false
            })
            /**
             * table_status 0/null/1 未开台 6禁用 -1外卖单
             * cor_status 审核状态： 0 审核中 1审核通过
             * select_menu 选中的菜单
             */
            // 桌台

            if (table_status !== 6) {
                // 初始化房间
                WebsocketClient.emitOrderClients({
                    event: 'MODIFY_DISH',
                    customer: Store.getState().orderTab.customer,
                    // dish: Store.getState().shoppingCart,
                    dish: {}
                })
                // 桌台id
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'tableId',
                    value: parseInt(`${table_id}`),
                })
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'tableName',
                    value: table_name,
                })
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'orderRequestMsg.tableId',
                    value: parseInt(`${table_id}`)
                })
            }
            // 跳转首页
            if (table_status === null || table_status === 0 || table_status === 1) {
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'orderTab.orderId',
                    value: 0
                })
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'isOpenTab',
                    value: false
                })
                ShoppingCart.metaData = {};
                ShoppingCart.globalRound = 1;
                Store.dispatch({
                    type: 'SYNCHRONIZE',
                    direction: 'STATE_TO_CACHING',
                })
                createHashHistory().push({ pathname: '/Home' });
            } else if (table_status === 3 || table_status === 2 || table_status === 4) {
                // 跳转菜单页
                // 底部导航菜单页面
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'viewPage',
                    value: 'menuPage',
                });

                // 人数
                if (customer_num) {
                    Store.dispatch({
                        type: 'SET_CACHING',
                        path: 'orderTab.person',
                        value: customer_num,
                    });
                    Store.dispatch({
                        type: 'SET_CACHING',
                        path: 'orderTab.childNum',
                        value: child_number,
                    });
                    Store.dispatch({
                        type: 'SET_CACHING',
                        path: 'orderTab.otherNum',
                        value: other_number,
                    });
                    Store.dispatch({
                        type: 'SET_CACHING',
                        path: 'orderTab.normalNum',
                        value: adult_number,
                    });
                    Store.dispatch({
                        type: 'SET_CACHING',
                        path: 'orderRequestMsg.adultNum',
                        value: adult_number
                    })
                    Store.dispatch({
                        type: 'SET_CACHING',
                        path: 'orderRequestMsg.childNum',
                        value: child_number
                    })
                    Store.dispatch({
                        type: 'SET_CACHING',
                        path: 'orderRequestMsg.otherNum',
                        value: other_number
                    })
                    Store.dispatch({
                        type: 'SET_CACHING',
                        path: 'orderRequestMsg.person',
                        value: customer_num
                    })
                    Store.dispatch({
                        type: 'SET_CACHING',
                        path: 'shoppingCart',
                        value: {}
                    })
                }
                // 菜单id
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'orderTab.menuList.main_group_id',
                    value: select_menu ? parseInt(select_menu) : ''
                })
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'orderRequestMsg.menu.main_group_id',
                    value: select_menu ? parseInt(select_menu) : ''
                })
                // 订单id
                if (order_head_id) {
                    Store.dispatch({
                        type: 'SET_CACHING',
                        path: 'orderTab.orderId',
                        value: order_head_id,
                    });
                    // 获取自动生成的客户名称
                    await this.getGenerateCustomerName(order_head_id)
                }

                if (cor_status === 0) {

                    // 弹出审核中
                    Store.dispatch({
                        type: 'SET_CACHING',
                        path: 'approvalStatus',
                        value: 'REVIEW',
                    })
                    Store.dispatch({
                        type: 'SET_CACHING',
                        path: 'orderTab.customer',
                        value: ''
                    })
                } else if (cor_status === 1) {
                    // table_status = 4 为已打预结单状态
                    if (table_status === 3 || table_status === 2 || table_status === 4) {
                        // 审核通过
                        Store.dispatch({
                            type: 'SET_CACHING',
                            path: 'approvalStatus',
                            value: 'NO',
                        })
                        // 记录聚客开桌状态
                        Store.dispatch({
                            type: 'SET_CACHING',
                            path: 'tableStatus',
                            value: true,
                        })
                    } else {
                        // 审核未通过
                        Store.dispatch({
                            type: 'SET_CACHING',
                            path: 'approvalStatus',
                            value: 'REVIEW',
                        })
                    }
                }
                // customer_num ? createHashHistory().push({ pathname: '/Main' }) : createHashHistory().push({ pathname: '/Home' });

            } else {
                this.messengerModule.say({
                    message: `${i18n.t('home_page_text_table_pause_use')}`,
                    level: "Error",
                });
            }
        }

        return {
            tableStatus,
            selectMenu: resultTableInfo?.select_menu,
        };
    }



    // *********************
    // 视图区
    // *********************
    render() {
        const { isShowHomeOrder, person, showPassword, orderCode, isOpenPIN, selectedMenuId, resultTableStatus } = this.state;
        const { specialMenu, normalMenu, disabledOrderBtn } = this.props;
        const checkCode = /^\d{4}$/.test(orderCode);
        const personRes = person.find((item) => item.num !== 0);
        // 空桌
        const isEmptyTable = Number(resultTableStatus?.[0]?.table_status) <= 1;
        // JK 开台，不得修改人数
        const disabledPerson = (!resultTableStatus?.[0]?.select_menu && (resultTableStatus?.[0]?.table_status === 3 ||
            resultTableStatus?.[0]?.table_status === 2)) ||
            resultTableStatus?.[0]?.table_status === 4;
        const isDisabled = disabledOrderBtn ||
            selectedMenuId === 0 ||
            (disabledPerson ? false : personRes === undefined) ||
            (isEmptyTable && this.openMode === 0)

        return (
            <React.Fragment>

                {/* 开台信息页面 */}
                {
                    isShowHomeOrder ?
                        <React.Fragment>
                            <div className="home-order">
                                <div className="home-order-topBar">
                                    <div className="goBack">
                                        < ArrowBackIosOutlinedIcon
                                            onClick={() => {
                                                this.setState({
                                                    isShowHomeOrder: false
                                                })
                                            }} />
                                    </div>
                                    <div style={{ flex: 1 }}>{i18n.t('auto_open_page_open_table')}</div>
                                </div>

                                <div
                                    className={this.getViewStyle()}
                                    style={{ top: this.state.inputAnimationStatus }}
                                >
                                    {/* 人数选择 disabledPerson JK开台不可以修改人数*/}
                                    {!disabledPerson && <div className="selectedCustomer">
                                        <div className="homeTitle">{i18n.t('text_persons')}</div>
                                        <div className="selected-box">
                                            {
                                                person.map((item, index) => (
                                                    <React.Fragment key={index}>
                                                        <div className="countNumBox" >
                                                            <div style={{ color: '#fff', fontSize: 14 }}>
                                                                {index === 1 ? i18n.t('auto_open_page_children') : (index === 0 ? i18n.t('auto_open_page_adults') : i18n.t('auto_open_page_other'))}
                                                            </div>
                                                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                <Button
                                                                    style={{ minWidth: 0 }}
                                                                    onClick={() => this.changePeoNum(-1, item.type)}
                                                                >
                                                                    <div className='countButton' style={{ color: '#fff' }}>
                                                                        -
                                                                    </div>
                                                                </Button>
                                                                <div style={{ color: '#fff', width: 30 }}>
                                                                    {item.num}
                                                                </div>
                                                                <Button
                                                                    style={{ minWidth: 0 }}
                                                                    onClick={() => this.changePeoNum(1, item.type)}
                                                                >
                                                                    <div className='countButton' style={{ color: '#fff' }}>
                                                                        +
                                                                    </div>
                                                                </Button>
                                                            </div>
                                                        </div>
                                                        {/* 分割线-- 兼容Android写法 */}
                                                        {
                                                            person.length - index > 1 &&
                                                            <div
                                                                style={{
                                                                    borderWidth: .8,
                                                                    borderStyle: 'dashed',
                                                                    borderColor: '#767C9D',
                                                                    borderRadius: 1,
                                                                    margin: '0 20px',
                                                                }}
                                                            />
                                                        }
                                                    </React.Fragment>
                                                ))
                                            }
                                        </div>
                                    </div>}
                                    {/* 选择菜单 */}
                                    <div className="selectedMenu">
                                        <div className="homeTitle">{i18n.t('auto_open_page_text_menu')}</div>
                                        <div className="selectedMenu-main">
                                            {/* 普通菜菜单 */}
                                            {
                                                _.has(normalMenu, 'main_group_name') &&
                                                <MenuItem
                                                    item={normalMenu}
                                                    selectedMenuId={this.state.selectedMenuId}
                                                    updateState={(val) => { this.selectMenu(val) }}
                                                />
                                            }
                                            {/* 特殊菜菜单 */}
                                            {
                                                specialMenu.map((item, index) => {
                                                    return (
                                                        <MenuItem
                                                            key={index}
                                                            item={item}
                                                            selectedMenuId={this.state.selectedMenuId}
                                                            updateState={(val) => this.selectMenu(val)}
                                                        />
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>

                                    {/* 订单临时密码 */}
                                    {
                                        !!isOpenPIN &&
                                        <div className="temporaryPassword">
                                            {/* <div style={{ height: 40 }} /> */}
                                            <div className="homeTitle marginTop-10">{i18n.t('auto_open_page_text_set_temporary_password')}</div>
                                            <FormControl variant="outlined">
                                                <TextField
                                                    type={showPassword ? 'text' : 'password'}
                                                    label={i18n.t('auto_open_page_pin')}
                                                    id="outlined-margin-normal"
                                                    helperText={checkCode || orderCode === '' ? '' : `${i18n.t('auto_open_page_text_input_password')}`}
                                                    margin="normal"
                                                    variant="outlined"
                                                    value={orderCode}
                                                    onChange={(event) => {
                                                        this.setState({ orderCode: event.target.value });
                                                    }}
                                                    onFocus={() => {

                                                        if (PHONE_TYPE.indexOf('Android') > -1) {
                                                            if (PHONE_TYPE.indexOf('XiaoMi') > -1) {
                                                                this.setState({
                                                                    inputAnimationStatus: -150
                                                                })
                                                            }
                                                        }
                                                    }}
                                                    onBlur={() => {
                                                        this.setState({
                                                            inputAnimationStatus: 0
                                                        })
                                                    }}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <IconButton
                                                                    aria-label="toggle password visibility"
                                                                    onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                                                                    onMouseDown={(event: React.MouseEvent<HTMLButtonElement>) => event.preventDefault()}
                                                                >
                                                                    {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                                                                </IconButton>
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                />
                                            </FormControl>
                                        </div>
                                    }
                                </div>

                            </div>
                            <div className="home-page-bottom">
                                <div className="table-name">
                                    <div className="freebrrak-icon"></div>
                                    <div>{getCacheField('tableName')}</div>
                                </div>
                                <div className={isDisabled ? 'order-now-disabled' : 'order-now'}>
                                    <Button
                                        style={{ display: 'flex', flex: 1 }}
                                        onClick={_.debounce(() => {
                                            // 如果不符合4位数字 && 不为空 跳出
                                            if (!checkCode && orderCode !== '') return;
                                            this.setState({ isLoading: true }, async() => {
                                                try {
                                                    await this.createOrder();
                                                } finally {
                                                    this.setState({
                                                        isLoading: false
                                                    })
                                                }
                                            })
                                        }, 300)}
                                        disabled={isDisabled || this.state.isLoading}
                                    >
                                        <div className="Jumplink-bottom">
                                            <div>{i18n.t('auto_open_page_text_order_now')}</div>
                                        </div>

                                    </Button>
                                </div>
                            </div>
                        </React.Fragment>
                        :
                        <FooterArea
                            updateState={async () => {
                                const { tableStatus, selectMenu } = await this.checkTableStatus();
                                if ((isEmptyTable || disabledPerson) && (!tableStatus || !selectMenu)) {
                                    this.setState({
                                        isShowHomeOrder: true
                                    }, () => {
                                        if (isEmptyTable && this.openMode === 0) {
                                            this.messengerModule.say({
                                                message: `${i18n.t('auto_open_page_text_disabled_message')}`,
                                                level: 'Warning'
                                            })
                                        }
                                    })
                                }
                                else {
                                    // Store.dispatch({
                                    //     type: 'SET_CACHING',
                                    //     path: 'orderTab.customer',
                                    //     value: getCacheField('orderTab.customer') || '1',
                                    // })
                                    // 防止二次开桌
                                    createHashHistory().push({ pathname: '/Main' });
                                }
                            }}
                            disabled={disabledOrderBtn}
                        />
                }




            </React.Fragment >
        )
    }

}
export default withSnackbar(FooterBar);

// **********
// TYPE
// **********

type Props = {
    // 普通菜单数据
    normalMenu: Menu;
    // 备选菜单数据
    specialMenu: Array<Menu>;
    // 禁用《立即点餐》按钮
    disabledOrderBtn: boolean;
} & WithSnackbarProps

type State = {

    isTouchMove: boolean;
    // 上下滑动数值
    touchStartY: number;
    touchEndY: number;
    // 是否显示开台编辑页面
    isShowHomeOrder: boolean;
    // 选择的菜单id
    selectedMenuId: number;
    // 人数
    person: Person[];
    // 当前桌台状态
    resultTableStatus: TableStatus[];
    isLoading: boolean;
    // 是否开启审核功能
    isApproved: boolean;
    // 自主点餐是否开启
    autonomous: {
        status: boolean
    };
    peopleArr: Array<string>;
    // 额外费用ID
    menuId: number;
    // 是否明文密码
    showPassword: boolean;
    // 订单加密码
    orderCode: string;
    // 输入框位移动画
    inputAnimationStatus: number;
    // 是否显示创建临时密码
    isOpenPIN: 0 | 1
}
type Person = {
    // 类型
    type: PersonType
    // 人数
    num: number
}
type PersonType = 'NORMAL' | 'CHILD' | 'OTHER';

/**
 * Home页面底部点餐跳转按钮
 */
export function FooterArea(props: {
    updateState: () => void;
    disabled?: boolean;
}) {
    return (
        <div className="home-page-bottom">
            <div className="table-name">
                <div className="freebrrak-icon"></div>
                <div>{getCacheField('tableName')}</div>
            </div>
            <div className={`${'order-now'}`}>
                <Button
                    style={{ display: 'flex', flex: 1 }}
                    onClick={() => {
                        props.updateState();
                    }}
                    disabled={props.disabled}
                >
                    <div className="Jumplink-bottom">
                        <div>{i18n.t('auto_open_page_text_order_now')}</div>
                    </div>

                </Button>
            </div>
        </div>
    )
}